// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2Kv0j","containerItemsCenter":"Skeleton_containerItemsCenter__3IKUD"};